import request from "@/utils/request";

export const getSetting = (key) => {
    return request({ url: `/setting/getSetting/${key}`, method: "get" });
};

export const setSetting = (key, value) => {
    return request({
        url: `/setting/setSetting/${key}`, method: "post", data: value, headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
    });
};

export const getMsgLimit = () => {
    return request({ url: `/setting/msg/limit`, method: "get" });
};

export const saveMsgLimit = (value) => {
    return request({
        url: `/setting/msg/limit`, method: "post", data: value, headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
    });
};

export const getDefaultAvatar = () => {
    return request({ url: `/setting/default/avatar`, method: "get" });
};

export const saveDefaultAvatar = (value) => {
    return request({
        url: `/setting/default/avatar`,
        method: "post",
        data: value,
        headers: {
            'Content-Type': 'text/plain;charset=UTF-8'
        },
    });
};

export const getMiniAppFeatures = () => {
    return request({ url: `/setting/miniapp/features`, method: "get" });
};

export const saveMiniAppFeatures = (value) => {
    return request({
        url: `/setting/miniapp/features`,
        method: "post",
        data: value,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
    });
};
